var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkerYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5602 39.0068C13.5002 38.8868 13.4602 38.7568 13.3902 38.6468C9.73016 33.3768 6.07016 28.1068 2.43016 22.8168C1.12016 20.9168 0.420156 18.7968 0.140156 16.5168C-0.219844 13.5868 0.120156 10.7368 1.32016 8.02677C3.25016 3.67677 6.62016 1.06677 11.2802 0.236769C15.8302 -0.573231 19.8202 0.706769 23.1702 3.89677C25.0602 5.69677 26.2002 7.95677 26.7902 10.4768C27.7402 14.5268 27.4102 18.4568 25.2902 22.0968C24.3002 23.7868 23.0902 25.3568 21.9802 26.9768C19.2802 30.8768 16.5802 34.7768 13.8802 38.6768C13.8102 38.7768 13.7802 38.8968 13.7302 39.0068C13.6602 39.0068 13.6102 39.0068 13.5602 39.0068ZM9.28016 13.5168C9.28016 15.9968 11.2802 17.9868 13.7602 17.9968C16.2502 17.9968 18.2802 15.9968 18.2802 13.5068C18.2802 11.0368 16.2402 8.99677 13.7702 8.99677C11.2802 9.00677 9.27016 11.0268 9.28016 13.5168Z",
    fill: "#FFB900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerYellow);
export default __webpack_public_path__ + "static/media/marker-yellow.26ef8b9345c9485d2cbc84257b305fd1.svg";
export { ForwardRef as ReactComponent };